import type { ReactNode } from 'react';

export const symbol_fireplace: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M414-269q14 11 29 16t31 5q30.91 0 55.95-19.5Q555-287 560-323q5-49-31-73.5T473-459q-5 16-5.5 27t3.5 27q3 20 8 34.5t1 33.5q-5 21-22.5 40.5T414-269ZM80-140v-680q0-24.75 17.63-42.38Q115.25-880 140-880h680q24.75 0 42.38 17.62Q880-844.75 880-820v680q0 24.75-17.62 42.37Q844.75-80 820-80H140q-24.75 0-42.37-17.63Q80-115.25 80-140Zm400.06-60q52.94 0 89.44-36.75T606-326q0-23-10.5-42T569-398q-42-26-66.5-65.5T467-533q-54 35-84 87t-30 117q0 71 38.12 100t88.94 29ZM140-140h100v-30.18q0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h66q-22-26-32.5-58T293-329q0-94 48-162t126-115q6-4 12.84-4t13 2q6.16 2 11.16 7t7 12q14 49 33 78t58 61q34 28 49 57t15 67q0 38.35-13 70.68Q640-223 616-200h74q12.75 0 21.38 8.62Q720-182.75 720-170v30h100v-680H140v680Zm340-60Z"
		/>
	</svg>
);
